import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';

export function LoadingSpinner({
  size = '5x',
  className,
}: {
  size?: SizeProp;
  className?: string;
}) {
  return (
    <div className={cn(className, 'flex h-full w-full items-center justify-center')}>
      <FontAwesomeIcon icon={solid('spinner')} spin size={size} />
      <span className='sr-only'>Loading...</span>
    </div>
  );
}
